/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-cycle */
import { FC } from 'react';
import { ICardIconDescriptionProps } from 'blades/CardIconDescriptionColumnsBlade/@types';
import ImageComponent from '../Image';
import Typo from '../Typo';
import styles from './cardIconDescription.module.sass';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';

const CardIconDescription: FC<ICardIconDescriptionProps> = ({ description, media, title }) => {
  const { isMobile } = useIsMobileViewport();

  return (
    <div className={styles.cardIconDescription}>
      <ImageComponent image={media} height="80px" width="80px" />
      <Typo medium={!isMobile} big={isMobile} classes={styles.title}>
        {title}
      </Typo>
      <Typo medium={!isMobile} big={isMobile} classes={styles.description}>
        {description}
      </Typo>
    </div>
  );
};

export default CardIconDescription;
